<template>
  <div class="landing-cnt row">
    <div class="bg-image"></div>
    <div class="col-12 d-xl-none d-lg-flex main-block-xs"></div>
    <!-- Main text block not logged -->
    <div class="text-block-ctn col-xl-6 col-12 d-flex my-auto">
      <div class="text-ctn my-auto">
        <h3>{{ $t('aca-error-title-page') }}</h3>
        <p>{{ $t('aca-error-detail-page') }}</p>
        <base-button class="mt-5" @click="$helpers.gotoACAUrl">{{ $t('retry') }}
        </base-button>
      </div>
    </div>
  </div>
</template>
<script>

import domains from '_static/domains.json'
export default {
  data () {
    return {
      myJson: domains
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalACAError.vue